import { Stack, useTheme } from '@mui/material';
import Typography from '@/components/Typography';
import useResponsive from '@/hooks/useResponsive';
import Image from 'next/image';
import { FC } from 'react';
import { BadgeProps } from './types';

const Badge: FC<BadgeProps> = ({ image, content, link, imageSize }) => {
  const { matches } = useResponsive();
  const theme = useTheme();

  return (
    <>
      <a
        href={link}
        target="_blank"
        aria-label="related link"
        style={{ textDecoration: 'none', color: theme.palette.textColor.A80 }}
      >
        <Stack
          direction="row"
          flexGrow={matches({ lg: 0, xs: 1 })}
          spacing={1.5}
          sx={{
            background: '#F0F6FF',
            px: 3,
            py: 1.5,
            borderRadius: '8px'
          }}
          justifyContent="center"
          alignItems="center"
        >
          <Image
            src={image}
            width={
              imageSize
                ? imageSize
                : image === '/assets/crypto/clown.svg' ||
                  image === '/assets/scam/clown.svg'
                ? 14
                : image === '/assets/crypto/link.svg' ||
                  image === '/assets/scam/link.svg'
                ? 13
                : 10
            }
            height={
              imageSize
                ? imageSize
                : image === '/assets/crypto/clown.svg' ||
                  image === '/assets/scam/clown.svg'
                ? 14
                : image === '/assets/crypto/link.svg' ||
                  image === '/assets/scam/link.svg'
                ? 13
                : 10
            }
            alt=""
          />
          <Typography
            variant="body3"
            sx={{
              display:
                image === '/assets/crypto/link.svg' ||
                image === '/assets/crypto/clown.svg' ||
                image === '/assets/scam/clown.svg' ||
                image === '/assets/scam/link.svg'
                  ? 'none'
                  : 'block'
            }}
          >
            {content}
          </Typography>
        </Stack>
      </a>
    </>
  );
};

export default Badge;
